<template>
  <main
    class="flex flex-col justify-center items-center min-h-screen container"
  >
    <img src="@/assets/images/logo-login.png" alt="logo" class="w-32 mb-10" />
    <p class="text-xl font-medium" style="color: #ac4e47">
      {{ $t("screen.auth.login.pleaseEnter") }}
    </p>
    <Form
      class="flex flex-col justify-center items-center mt-4"
      @submit="onSubmit"
    >
      <div class="relative flex">
        <Field
          :placeholder="$t('screen.auth.login.nickname')"
          class="w-64 h-10 bg-gray-300 rounded-2xl px-4 mb-5"
          name="nickname"
          as="input"
          rules="required"
          v-model="loginid"
        />
        <ErrorMessage
          name="nickname"
          class="
            text-xs text-red-600
            absolute
            left-2
            bottom-0.5
            whitespace-nowrap
          "
        />
      </div>
      <div class="relative flex">
        <Field
          type="password"
          :placeholder="$t('screen.auth.login.password')"
          class="w-64 h-10 bg-gray-300 rounded-2xl px-4 mb-6"
          name="password"
          as="input"
          rules="required"
          v-model="password"
        />
        <ErrorMessage
          name="password"
          class="
            text-xs text-red-600
            absolute
            left-2
            bottom-2
            whitespace-nowrap
          "
        />
      </div>
      <p class="mb-6 font-medium text-sm">
        {{ $t("screen.auth.login.noCollectPersonal") }}
      </p>
      <div class="w-full flex justify-center items-center">
        <button
          type="submit"
          class="px-8 py-2 rounded-2xl text-white font-medium mb-6"
          style="background-color: #ac4e47"
        >
          {{ $t("screen.register.join") }}
        </button>
      </div>
    </Form>
    <router-link
      :to="{
        name: 'Login',
      }"
      class="underline"
      >{{ $t("screen.register.login") }}</router-link
    >
  </main>
</template>
<script>
import services from "../../services";
import { Form, Field, ErrorMessage, defineRule, configure } from "vee-validate";
import { required } from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";
import { setLocale } from "@vee-validate/i18n";

defineRule("required", required);

configure({
  generateMessage: localize({
    en: {
      names: {
        nickname: "nickname",
        password: "password",
      },
      messages: {
        required: "{field} is required.",
      },
    },
    ja: {
      names: {
        nickname: "ニックネーム",
        password: "パスワード",
      },
      messages: {
        required: "{field}を入力してください。",
      },
    },
    ko: {
      names: {
        nickname: "닉네임",
        password: "패스워드",
      },
      messages: {
        required: "{field}을(를) 입력해주세요.",
      },
    },
    zh: {
      names: {
        nickname: "绰号(儿)",
        password: "密码",
      },
      messages: {
        required: "您必須輸入{field}。",
      },
    },
  }),
});
export default {
  components: { Form, Field, ErrorMessage },
  data() {
    return {
      loginid: "",
      password: "",
      country: "KR",
      vh: window.innerHeight * 0.01,
    };
  },
  mounted() {
    window.addEventListener("resize", this.setScreenSize());
    if (this.$store.getters.getLocale) {
      setLocale(this.$store.getters.getLocale.code);
    } else {
      setLocale("ko");
    }
  },
  methods: {
    setScreenSize() {
      document.documentElement.style.setProperty("--vh", `${this.vh}px`);
    },
    async onSubmit() {
      const forbiddenWords = [
        "sex",
        "shit",
        "fuck",
        "fuck you",
        "fucking",
        "섹스",
        "강간",
        "개년",
        "개놈",
        "개세이",
        "개자식",
        "꼬추",
        "꼴리",
        "꼴려",
        "니미",
        "딸딸이",
        "똥",
        "레즈",
        "미친",
        "발기",
        "번색",
        "병신",
        "보지",
        "부랄",
        "불알",
        "브지",
        "빙신",
        "빠구리",
        "빠굴",
        "뽀르노",
        "새끈",
        "새끼",
        "색녀",
        "색스",
        "색폰",
        "섹",
        "쉐이",
        "시펄",
        "쌍년",
        "쌍놈",
        "쌕",
        "썅",
        "쌔끈",
        "쓰바",
        "씨바",
        "씨발",
        "씨벌",
        "씨부",
        "씨불",
        "씨브랄",
        "씨팔",
        "씨펄",
        "씹",
        "씹새",
        "씹세",
        "씹쉐",
        "씹쌔",
        "씹탱",
        "씹할",
        "오랄",
        "오르가즘",
        "원조",
        "유방",
        "자위",
        "자지",
        "절라",
        "젖꼭지",
        "조까",
        "조로",
        "조루",
        "졸라",
        "좃나",
        "좆",
        "좇",
        "지랄",
        "지미랄",
        "창녀",
        "포르노",
        "폰색",
        "호모",
        "존나",
        "시발",
        "씌발",
        "씌이발​",
      ];
      if (forbiddenWords.includes(this.loginid)) {
        alert(this.$t("screen.register.overlapCheckFalse"));
        this.loginid = "";
      } else {
        const params = {
          loginid: this.loginid,
          username: this.loginid,
          password: this.password,
          languege: this.$i18n.locale,
          country: this.country,
        };
        await services.regUser(params).then(
          () => {
            this.$router.push({
              name: "Login",
            });
          },
          (error) => {
            const { data } = error.response;
            console.log(data);
          }
        );
      }
    },
  },
};
</script>
<style scoped>
.container {
  min-height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
}
</style>